module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pt-4": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', [_c('v-layout', {
    staticClass: "px-3 pt-3 pb-0",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('datetime', {
    staticClass: "datetime-btn primary--text mx-2",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.labels.fromDate
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }), _vm._v(" "), _c('datetime', {
    staticClass: "datetime-btn primary--text mx-2",
    attrs: {
      "phrases": {
        ok: _vm.$lang.actions.ok,
        cancel: _vm.$lang.actions.cancel
      },
      "type": "datetime",
      "placeholder": _vm.$lang.labels.toDate
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md3": "",
      "px-2": ""
    }
  }, [_c('v-select', {
    staticClass: "min-w max-w",
    attrs: {
      "chips": "",
      "deletable-chips": "",
      "hide-details": "",
      "multiple": "",
      "items": _vm.statuses,
      "label": _vm.$lang.labels.status
    },
    model: {
      value: (_vm.selectedStatuses),
      callback: function($$v) {
        _vm.selectedStatuses = $$v
      },
      expression: "selectedStatuses"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left text-md-right",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-2": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary mx-0",
    on: {
      "click": function($event) {
        return _vm.showDetails()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.showDetails))])], 1)], 1)], 1), _vm._v(" "), (true) ? _c('div', [_c('v-card-title', {
    staticClass: "pb-0 px-4 layout row wrap"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    staticClass: "min-w max-w",
    attrs: {
      "append-icon": "search",
      "label": _vm.$lang.labels.search,
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.orders,
      "search": _vm.search,
      "loading": _vm.ordersLoading,
      "rows-per-page-items": [50, 100, 250, 500, {
        text: 'All',
        value: -1
      }]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-btn', {
          staticClass: "primary--text ma-0",
          attrs: {
            "flat": ""
          },
          on: {
            "click": function($event) {
              return _vm.showModal(props.item.webShopOrderId)
            }
          }
        }, [_vm._v("\n              " + _vm._s(props.item.webShopOrderId) + "\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "d-block",
          staticStyle: {
            "padding": "0 16px"
          }
        }, [_vm._v(_vm._s(props.item.webShopOrderSourceSystem))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.orderId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(parseFloat(props.item.totalAmount).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(props.item.email) + "\n            "), _c('div', {
          staticClass: "d-block mt-1"
        }, [_vm._v(_vm._s(props.item.phone))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))])]
      }
    }], null, false, 3291402343)
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "height": "6",
      "color": "primary",
      "indeterminate": ""
    },
    slot: "progress"
  }), _vm._v(" "), _vm._v(" "), _c('v-alert', {
    attrs: {
      "slot": "no-results",
      "value": true,
      "color": "warning",
      "icon": "warning"
    },
    slot: "no-results"
  }, [_vm._v("\n          Your search for \"" + _vm._s(_vm.search) + "\" found no results.\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-0 close-btn",
    attrs: {
      "absolute": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'webShop'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n      " + _vm._s(_vm.$lang.actions.close) + "\n    ")], 1)], 1), _vm._v(" "), (_vm.lastOrderModal) ? _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.lastOrderModal),
      callback: function($$v) {
        _vm.lastOrderModal = $$v
      },
      expression: "lastOrderModal"
    }
  }, [_c('last-order-modal', {
    attrs: {
      "lastOrder": _vm.lastOrder
    },
    on: {
      "close": function($event) {
        _vm.lastOrderModal = false
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8703fd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/webShop/WebShopOrder.vue
// module id = 436
// module chunks = 35